import { CatalogTypeGift } from './../../models/promotion-catalog-gift-type.model';
import { HttpClientService } from './../httpClient/httpclient.service';
import { ListMetadata } from './../../models/list-metadata.model';
import { Observable } from 'rxjs/Rx';
import { Injectable } from '@angular/core';
import { publishReplay, refCount } from 'rxjs/operators';

@Injectable()
export class PromotionCatalogTypeGiftService {

  baseUrl = '/koncentro-promo';
  cachedCatalogFields: Observable<any>;


  constructor(private http: HttpClientService) { }

  /**
   * Tramite metodo GET, restituisce la lista della tipologia premi.
   * Prevede obbligatoriamente un offset ed un limite, permettendo la paginazione della lista.
   */
  list(
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<{ data: Array<CatalogTypeGift>, metadata: ListMetadata }> {
    const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    return this.http.getPaged(this.baseUrl + '/catalog-gift/type' +
      (params.toString() ? '?' + params.toString().replace(/\+/gi, '%2B').replace(/'/gi, "''") : '' ));
  }

  /**
   * DTO Form Tipologia premi
   */
  getCatalogTypeGiftFields() {
    if (!this.cachedCatalogFields) {
      this.cachedCatalogFields = this.http.get(`${this.baseUrl}/schema/CatalogTypeGiftDto`).pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedCatalogFields;
  }

  /**
   * Salva una nuova tipologia di premi
   */
  createCatalogTypeGift(data: any) {
    return this.http.post(`${this.baseUrl}/catalog-gift/type`, data);
  }


  /**
   * Modifica una nuova tipologia di premi
   */
  updateCatalogTypeGift(id: number, data: any) {
    return this.http.put(`${this.baseUrl}/catalog-gift/type/${id}`, data);
  }

  /**
   * Elimina una nuova tipologia di premi
   */
  deleteCatalogTypeGift(id: number) {
    return this.http.delete(`${this.baseUrl}/catalog-gift/type/${id}`);
  }

  /**
   * Recupera una tipologia di premi tramite l'id con una chiamata get
   * @param id l'id della tipologia premi
   * @returns i campi della tipologia premi chiamata
   */
  getCatalogTypeGift(id: number){
    return this.http.get(`${this.baseUrl}/catalog-gift/type/${id}`);
  }


}



// WEBPACK FOOTER //
// ./src/app/services/promotion/promotion-catalog-type-gift.service.ts